import React, { useMemo, useState } from 'react';

import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { FORM_MODE } from '@awp/constants';
import { getUtcToLocalByBreakpoints } from '@awp/helpers/utilsReact';
import * as PresetHelper from './Helpers/PresetHelper';

export const PresetTableColumns = ({ ...columnProps }) => {
  return [
    {
      Header: 'Name',
      accessor: 'Name',
      Cell: (props) => {
        return props.row.original.IsPublic ? (
          <div>
            <i className="fas fa-solid fa-globe mx-1 my-1" title="Public" />
            {props.value}
          </div>
        ) : (
          <div>
            <i className="fas fa-solid fa-user mx-1 my-1" title="Private" />
            {props.value}
          </div>
        );
      },
    },
    {
      Header: 'Last Updated',
      accessor: 'AppLastUpdateTimestamp',
      sortType: sortByNumericThenAlpha,
      Cell: (props) => {
        const timestamp = props.row.original.AppLastUpdateTimestamp
          ? props.value
          : props.row.original.AppCreateTimestamp;
        return getUtcToLocalByBreakpoints(timestamp, columnProps.breakpoints);
      },
    },
    {
      Header: 'Actions',
      accessor: 'id',
      disableSortBy: true,
      Cell: (props) => {
        return actionMenu(
          props,
          columnProps.dispatch,
          columnProps.setMode,
          columnProps.setPresetId,
          columnProps.setShowDeleteModal,
          columnProps.setActionId,
          columnProps.currentUser,
        );
      },
    },
  ];
};

const actionMenu = (props, dispatch, setMode, setPresetId, setShowDeleteModal, setActionId, currentUser) => {
  const record = props.row.original;

  const { canManagePrivate, canManagePublic } = PresetHelper.getManagePermissions(currentUser);

  return (
    <>
      <div>
        {(canManagePublic && record.IsPublic) || (!record.IsPublic && canManagePrivate) ? (
          <i
            className="fas fa-edit mx-1 my-1 awp-img-btn"
            title="Edit"
            onClick={() => {
              setMode(FORM_MODE.EDIT);
              setPresetId(record.GraphPresetId);
            }}
          />
        ) : null}
        <i
          className="fas fa-eye mx-1 my-1 awp-img-btn"
          title="View"
          onClick={() => {
            setMode(FORM_MODE.VIEW);
            setPresetId(record.GraphPresetId);
          }}
        />
        {(canManagePublic && record.IsPublic) || (!record.IsPublic && canManagePrivate) ? (
          <i
            className="fas fa-trash mx-1 my-1 awp-img-btn"
            title="Delete"
            onClick={() => {
              //delete preset using modal
              setActionId(record.GraphPresetId);
              setShowDeleteModal(true);
            }}
          />
        ) : null}
      </div>
    </>
  );
};
